const ACCESS_TOKEN_KEY = 'access-token'
const REFRESH_TOKEN_KEY = 'refresh-token'
const LEGACY_TOKEN_KEY = 'auth-token'
const EXPIRES_AT_KEY = 'token-expires-at'

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY)
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY)
export const getLegacyToken = () => localStorage.getItem(LEGACY_TOKEN_KEY)

export const getAuthToken = () => getAccessToken() || getLegacyToken()

export const isAuthenticated = () => !!getAuthToken()

export const setTokens = ({ accessToken, refreshToken, expiresIn }) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
  const expiresAt = Date.now() + (expiresIn - 30) * 1000
  localStorage.setItem(EXPIRES_AT_KEY, String(expiresAt))
  localStorage.setItem(LEGACY_TOKEN_KEY, accessToken)
}

export const clearAllTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem(REFRESH_TOKEN_KEY)
  localStorage.removeItem(LEGACY_TOKEN_KEY)
  localStorage.removeItem(EXPIRES_AT_KEY)
}

let refreshPromise = null

export const getRefreshPromise = () => refreshPromise
export const setRefreshPromise = (promise) => { refreshPromise = promise }
export const clearRefreshPromise = () => { refreshPromise = null }
